<template>
  <div class="map-container">
    <div id="map-root"></div>
    <switch-control
      ref="control"
      :outerLayers="layers"
      @switchMap="switchMap"
      @switchObjectLayer="switchObjectLayer"
      @switchCombinedLayer="switchCombinedLayer"
      @zoomIn="zoomIn"
      @zoomOut="zoomOut"
      @measure="measure"
      @measureClear="measureClear"
    ></switch-control>
    <!-- <threeD></threeD>
    <cal-elec></cal-elec> -->
    <!--switchControl2 v-if="showDgLayer && currentZoom >= 12" :currentZoom="currentZoom" @drawDgLayer="drawDgLayer"></switchControl2-->
  </div>
</template>

<script>
const HOST = process.env.VUE_APP_LAYER_HOST;
import L from 'leaflet';
import '@geoman-io/leaflet-geoman-free';
import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css';
import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';
import find from 'lodash/find';
import './measure/Leaflet.PolylineMeasure';
import './pos/control.pos';
import SwitchControl from './switch-control';
import switchControl2 from './switch-control2';
//import CalElec from './cal-elec';
// import threeD from './three-d';
import getLayer from './layer';
import { isSameLatLng, getLatLngs } from './util';
import WindMixin from './mixins/wind-mixin';
import MotionMixin from './mixins/motion-mixin';
import LayerMixin from './mixins/layer-mixin';
import defaultIcon from './marker-icon.png';

const getDefaultToolbarStatus = () => ({
  drag: false,
  edit: false,
  remove: false,
  drawMarker: false,
  drawCircleMarker: false,
  drawPolyline: false,
  drawRectangle: false,
  drawPolygon: false
  // drawCircle: false,
});

export default {
  components: {
    SwitchControl,
    switchControl2
    // threeD
  },
  mixins: [WindMixin, MotionMixin, LayerMixin],
  props: {
    type: {
      type: String,
      default: () => 'Satellite' // Normal, Satellite
    },
    // 地图当前中心点
    center: {
      type: Array,
      default: () => [34.5, 104]
    },
    zoom: {
      type: Number,
      default: () => 5
    },
    zoomSnap: {
      type: Number,
      default: () => 0.25
    },
    minZoom: {
      type: Number,
      default: () => 3
    },
    maxZoom: {
      type: Number,
      default: () => 18
    },
    toolbar: {
      type: Object,
      default: () => ({
        drawCircleMarker: true,
        drawPolyline: true,
        drawRectangle: true,
        drawPolygon: true,
        editMode: true,
        removalMode: true,
        dragMode: true
      })
    },
    toolbarStatus: {
      type: Object,
      default: getDefaultToolbarStatus
    },
    // 点线面数据，使用 v-model
    value: {
      type: Object,
      default: () => ({
        markers: [],
        points: [],
        polylines: [],
        polygons: [],
        rectangles: []
      })
    },
    getStyle: {
      type: Function,
      default: () => null
    },
    drawOptions: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      // 存放 leaflet 的 shape，需要和 value 进行同步
      shapes: {
        markers: [],
        points: [],
        polylines: [],
        polygons: [],
        rectangles: [],
        images: [],
        towers: [], // 测风塔
        planes: [] // 风电场
      },
      circleLayer: null,
      currentZoom: null,
      dgLayer: null,
      showDgLayer: true,
      dgRadio: true,
      wmsLayers: null,
      defaultLayer: null,
      defaultImgLayer: null
    };
  },
  watch: {
    value() {
      this.render();
    },
    toolbarStatus() {
      this.syncToolbarStatus();
    }
  },
  methods: {
    syncToolbarStatus() {
      if (!this.map) return;

      const { pm } = this.map;

      const toolbarStatus = this.toolbarStatus;
      if (Boolean(toolbarStatus.drag) !== Boolean(pm.globalDragModeEnabled())) {
        this.map.pm.toggleGlobalDragMode();
      }
      if (Boolean(toolbarStatus.edit) !== Boolean(pm.globalEditEnabled())) {
        this.map.pm.toggleGlobalEditMode();
      }
      if (
        Boolean(toolbarStatus.remove) !== Boolean(pm.globalRemovalEnabled())
      ) {
        this.map.pm.toggleGlobalRemovalMode();
      }
      if (
        Boolean(toolbarStatus.drawCircleMarker) !==
        Boolean(pm.Draw.CircleMarker.enabled())
      ) {
        this.map.pm.Draw.CircleMarker.toggle();
      }
      if (
        Boolean(toolbarStatus.drawMarker) !== Boolean(pm.Draw.Marker.enabled())
      ) {
        this.map.pm.Draw.Marker.toggle();
      }
      if (
        Boolean(toolbarStatus.drawPolyline) !== Boolean(pm.Draw.Line.enabled())
      ) {
        this.map.pm.Draw.Line.toggle(this.drawOptions);
      }
      if (
        Boolean(toolbarStatus.drawRectangle) !==
        Boolean(pm.Draw.Rectangle.enabled())
      ) {
        this.map.pm.Draw.Rectangle.toggle(this.drawOptions);
      }
      if (
        Boolean(toolbarStatus.drawPolygon) !==
        Boolean(pm.Draw.Polygon.enabled())
      ) {
        this.map.pm.Draw.Polygon.toggle(this.drawOptions);
      }
      const editing = find(
        Object.keys(toolbarStatus),
        key => toolbarStatus[key]
      );
      if (editing && this.measureInstance?._measuring) {
        this.measureInstance._finishPath();
      }
    },
    resetToolbarStatus(cb) {
      const status = getDefaultToolbarStatus();
      this.$emit('update:toolbarStatus', status);
      setTimeout(cb, 0);
    },
    init() {
      this.currentZoom = this.zoom;
      const [gaode, tiandi] = getLayer(this.type, {
        maxZoom: this.maxZoom,
        minZoom: this.minZoom
      });
      this.gaode = gaode;
      this.tiandi = tiandi;
      this.map = L.map('map-root', {
        crs: L.CRS.EPSG3857,
        center: this.center,
        zoom: this.zoom,
        maxZoom: this.maxZoom,
        minZoom: this.minZoom,
        zoomSnap: this.zoomSnap,
        layers: [this.tiandi],
        zoomControl: false,
        attributionControl: false,
        //doubleClickZoom: false,
        maxBounds: [
          [-360, -360],
          [360, 360]
        ]
      });
      // L.control
      //   .scale({
      //     imperial: false
      //   })
      //   .addTo(this.map);
      // L.control.pos().addTo(this.map);
      L.Marker.prototype.options.icon = L.icon({
        iconUrl: defaultIcon,
        iconSize: [15, 20],
        iconAnchor: [7.5, 20],
      });
      L.control
        .scale({
          imperial: false
        })
        .addTo(this.map);
      L.control.pos().addTo(this.map);
      this.measureInstance = L.control
        .polylineMeasure({
          position: 'bottomright',
          // 关闭默认的控件
          showControl: false,
          beforeStart: cb => this.resetToolbarStatus(cb)
        })
        .addTo(this.map);
      this.map.pm.setLang('zh');
      this.map.pm.addControls({
        position: 'topright',
        ...this.toolbar,
        // 以下不支持，在此覆盖掉
        drawMarker: false,
        drawCircle: false,
        cutPolygon: false
      });

      this.map.on('pm:create', e => this.create(e));
      this.map.on('pm:remove', e => this.remove(e));
      this.map.on('pm:cut', e => this.cut(e));
      this.map.on('pm:globaleditmodetoggled', e => this.globalEdit(e));

      this.map.on('zoomend', e => {
        this.currentZoom = e.target.getZoom();
        // console.log(this.currentZoom);
        if(this.currentZoom < 12){
          if(this.dgLayer){
            this.map.removeLayer(this.dgLayer);
            this.dgLayer = null;
          }
        }
      });

      const layerPane = this.map.createPane('layerPane');
      // 介于 tilePane 和 overlayPane 之间
      layerPane.style.zIndex = 300;
      this.initDefaultMarker();
      this.render();
    },
    globalEdit(e) {
      const { polylines, polygons, rectangles } = this.shapes;
      if (e.enabled) {
        if (!isEmpty(polylines)) {
          polylines.forEach(shape => {
            shape.pm._markers.forEach(m => {
              m.on('click', mEvent => {
                this.$emit('vertexclick', {
                  type: 'polylines',
                  data: shape.__data,
                  latlng: mEvent.latlng
                });
              });
            });
          });
        }
        if (!isEmpty(polygons)) {
          polygons.forEach(shape => {
            let markers = shape.pm._markers;
            if (isArray(markers[0])) {
              markers = markers[0];
            }
            markers.forEach(m => {
              m.on('click', mEvent => {
                this.$emit('vertexclick', {
                  type: 'polygons',
                  data: shape.__data,
                  latlng: mEvent.latlng
                });
              });
            });
          });
        }
        if (!isEmpty(rectangles)) {
          rectangles.forEach(shape => {
            shape.pm._cornerMarkers.forEach(m => {
              m.on('click', mEvent => {
                this.$emit('vertexclick', {
                  type: 'rectangles',
                  data: shape.__data,
                  latlng: mEvent.latlng
                });
              });
            });
          });
        }
      }
    },
    vertexAdd(e) {
      const { marker, target } = e;
      let type;
      if (target instanceof L.Rectangle) {
        type = 'rectangles';
      } else if (target instanceof L.Polygon) {
        type = 'polygons';
      } else if (target instanceof L.Polyline) {
        type = 'polylines';
      }
      marker.on('click', mEvent => {
        this.$emit('vertexclick', {
          type,
          data: target.__data,
          latlng: mEvent.latlng
        });
      });
    },
    create(e) {
      //console.log('create', e);
      const { shape, layer } = e;
      const { markers, points, polylines, polygons, rectangles } = this.shapes;
      const value = { ...this.value };
      let type;
      let data;
      if (shape === 'Marker') {
        type = 'markers';
        data = layer.getLatLng();
        value.markers = [...value.markers, data];
        markers.push(layer);
      } else if (shape === 'CircleMarker') {
        type = 'points';
        data = layer.getLatLng();
        value.points = [...value.points, data];
        points.push(layer);
      } else if (shape === 'Line') {
        type = 'polylines';
        const latlngs = layer.getLatLngs();
        data = getLatLngs(latlngs);
        value.polylines = [...value.polylines, data];
        polylines.push(layer);
      } else if (shape === 'Polygon') {
        type = 'polygons';
        const latlngs = layer.getLatLngs();
        data = getLatLngs(latlngs);
        value.polygons = [...value.polygons, getLatLngs(latlngs)];
        polygons.push(layer);
      } else if (shape === 'Rectangle') {
        type = 'rectangles';
        const latlngs = layer.getLatLngs();
        data = getLatLngs(latlngs);
        value.rectangles = [...value.rectangles, getLatLngs(latlngs)];
        rectangles.push(layer);
      }
      this.$emit('input', value);
      this.$emit('create', {
        type,
        data
      });
      layer
        .on('pm:edit', e => this.edit(e))
        .on('pm:vertexadded', e => this.vertexAdd(e))
        .on('click', e => this.click(e));
    },
    click(e) {
      const { target } = e;
      let type;
      if (target instanceof L.Rectangle) {
        type = 'rectangles';
      } else if (target instanceof L.Polygon) {
        type = 'polygons';
      } else if (target instanceof L.CircleMarker) {
        type = 'points';
      } else if (target instanceof L.Polyline) {
        type = 'polylines';
      } else if (target instanceof L.Marker) {
        type = 'markers';
      }
      this.$emit('click', { data: target.__data, type, map: this.map });
    },
    edit(e) {
      //console.log('edit', e);
      const { target } = e;
      const { points, polylines, polygons, rectangles, markers } = this.shapes;
      const value = { ...this.value };
      if (target instanceof L.Rectangle) {
        const latlngs = target.getLatLngs();
        const index = rectangles.indexOf(target);
        value.rectangles = [...value.rectangles];
        value.rectangles[index] = getLatLngs(latlngs);
      } else if (target instanceof L.Polygon) {
        const latlngs = target.getLatLngs();
        const index = polygons.indexOf(target);
        value.polygons = [...value.polygons];
        value.polygons[index] = getLatLngs(latlngs);
      } else if (target instanceof L.CircleMarker) {
        const latlng = target.getLatLng();
        const index = points.indexOf(target);
        const origin = value.points[index];
        value.points = [...value.points];
        value.points[index] = { ...origin, ...latlng };
      } else if (target instanceof L.Polyline) {
        const latlngs = target.getLatLngs();
        const index = polylines.indexOf(target);
        value.polylines = [...value.polylines];
        value.polylines[index] = getLatLngs(latlngs);
      } else if (target instanceof L.Marker) {
        const latlng = target.getLatLng();
        const index = markers.indexOf(target);
        if (index !== -1) {
          const origin = value.markers[index];
          value.markers = [...value.markers];
          value.markers[index] = { ...origin, ...latlng };
        }
      }
      this.$emit('input', value);
    },
    remove(e) {
      //console.log('remove', e);
      const { shape, layer } = e;
      const { points, polylines, polygons, rectangles } = this.shapes;
      const value = { ...this.value };
      if (shape === 'CircleMarker') {
        const index = points.indexOf(layer);
        points.splice(index, 1);
        value.points.splice(index, 1);
      } else if (shape === 'Line') {
        const index = polylines.indexOf(layer);
        polylines.splice(index, 1);
        value.polylines.splice(index, 1);
      } else if (shape === 'Polygon') {
        const index = polygons.indexOf(layer);
        polygons.splice(index, 1);
        value.polygons.splice(index, 1);
      } else if (shape === 'Rectangle') {
        const index = rectangles.indexOf(layer);
        rectangles.splice(index, 1);
        value.rectangles.splice(index, 1);
      }
      this.$emit('input', value);
    },
    drawCircle(dataArr){
      const _this = this;
      if(_this.circleLayer){
        _this.map.removeLayer(_this.circleLayer);
      }
      if(dataArr.length == 0){

      }else{
        this.circleLayer = L.layerGroup();
        dataArr.forEach((data, i) => {
          data.addTo(_this.circleLayer);
        });
        _this.circleLayer.addTo(_this.map);
      }

    },
    render() {
      this.sync('points');
      this.sync('polylines');
      this.sync('polygons');
      this.sync('rectangles');
      this.sync('markers');
      this.syncImage();
      if (!isEmpty(this.renderFuncs)) {
        this.renderFuncs.forEach(func => func());
      }
    },
    syncImage() {
      const shapes = this.shapes.images;
      const dataArr = this.value.images || [];
      dataArr.forEach((data, i) => {
        if (!shapes[i]) {
          shapes[i] = L.imageOverlay(
            data.url,
            data.latlngs.map(l => [l.lat, l.lng]),
            { opacity: 0.5 }
          ).addTo(this.map);
        } else {
          const bounds = shapes[i].getBounds();
          if (
            !isSameLatLng(data.latlngs, [bounds._southWest, bounds._northEast])
          ) {
            shapes[i].setBounds(data.latlngs.map(l => [l.lat, l.lng]));
          }
          if (shapes[i]._url !== data.url) {
            shapes[i].setUrl(data.url);
          }
        }
      });
      if (shapes.length > dataArr.length) {
        const removed = shapes.splice(
          dataArr.length,
          shapes.length - dataArr.length
        );
        removed.forEach(r => r.remove());
      }
    },
    getIcon(data) {
      if (typeof data.icon === 'string') {
        return L.icon({
          iconUrl: data.icon,
          iconSize: data.iconSize || [20, 20],
          iconAnchor: data.iconAnchor || [10, 20]
        });
      }
      return data.icon;
    },
    sync(type) {
      const shapeArr = this.shapes[type];
      const dataArr = this.value[type] || [];
      const creatorMap = {
        points: 'circleMarker',
        polylines: 'polyline',
        polygons: 'polygon',
        rectangles: 'rectangle',
        markers: 'marker'
      };
      let latLngAction = 'LatLngs';
      if (['points', 'markers'].indexOf(type) !== -1) {
        latLngAction = 'LatLng';
      }
      dataArr.forEach((data, i) => {
        let opts = {};
        let latlngs = data;
        if (this.getStyle) {
          const style = this.getStyle(type, data, i);
          if (style) {
            opts = { ...opts, ...style };
          }
        }
        if (!isArray(data) && data.latlngs) {
          opts.color = data.color;
          latlngs = data.latlngs;
        }
        if (!shapeArr[i]) {
          if (type === 'markers') {
            opts.icon = this.getIcon(data);
          }
          shapeArr[i] = L[creatorMap[type]](latlngs, opts)
            .addTo(this.map)
            .on('pm:edit', e => this.edit(e))
            .on('pm:vertexadded', e => this.vertexAdd(e))
            .on('click', e => this.click(e));
        } else {
          if (!isSameLatLng(latlngs, shapeArr[i][`get${latLngAction}`]())) {
            shapeArr[i][`set${latLngAction}`](data);
            if (shapeArr[i].setStyle) {
              shapeArr[i].setStyle(opts);
            }
          }
          if (this.getStyle) {
            const style = this.getStyle(type, data, i);
            if (style) {
              shapeArr[i].setStyle(style);
            }
          }
          if (type === 'markers') {
            if (data.icon) {
              shapeArr[i].setIcon(this.getIcon(data));
            } else {
              shapeArr[i].setIcon(L.Marker.prototype.options.icon);
            }
          }
        }
        shapeArr[i].__data = data;
        shapeArr[i].__dataArr = dataArr;
        if (!shapeArr[i].binded) {
          if (type === 'points') {
            shapeArr[i]
              .on('mouseover', () => {
                this.$emit('pointover', {
                  point: shapeArr[i].__data,
                  points: shapeArr[i].__dataArr
                });
              })
              .on('mouseout', () => {
                this.$emit('pointout', {
                  point: shapeArr[i].__data,
                  points: shapeArr[i].__dataArr
                });
              });
          } else if (type === 'markers') {
            shapeArr[i]
              .on('mouseover', () => {
                this.$emit('markerover', {
                  marker: shapeArr[i].__data,
                  markers: shapeArr[i].__dataArr
                });
              })
              .on('mouseout', () => {
                this.$emit('markerout', {
                  marker: shapeArr[i].__data,
                  markers: shapeArr[i].__dataArr
                });
              });
          }
          shapeArr[i].binded = true;
        }
      });
      if (shapeArr.length > dataArr.length) {
        const removed = shapeArr.splice(
          dataArr.length,
          shapeArr.length - dataArr.length
        );
        removed.forEach(r => r.remove());
      }
    },
    switchMap(map) {
      try {
        if (map === 'tiandi') {
          this.map.removeLayer(this.gaode);
          this.map.addLayer(this.tiandi);
        } else {
          this.map.removeLayer(this.tiandi);
          this.map.addLayer(this.gaode);
        }
      } catch (e) {
        // console.error(e);
      }
    },
    initDefaultMarker() {
      this.defaultMarker = L.Marker.prototype.options.icon;
    },
    drawDgLayer(urlObject){
      console.log(urlObject);
      if(urlObject.contourC){
        if(this.dgLayer){
          return;
        }
        this.dgLayer = L.layerGroup();
        const option = {
          pane: 'layerPane',
          maxZoom: this.maxZoom,
          minZoom: 12,
          maxNativeZoom: this.maxZoom,
          reuseTiles: true,
          tms: true,
          opacity: 1
        }
        L.tileLayer(urlObject.demc,{...option}).addTo(this.dgLayer);
        L.tileLayer(urlObject.contourC,{...option}).addTo(this.dgLayer);
        // const option = {
        //   layers: 'dx:contourC',
        //   format: 'image/png',
        //   transparent: true,
        //   version: '1.3.0'
        // }
        // L.tileLayer.wms(urlObject.demc,{...option}).addTo(this.dgLayer);
        // L.tileLayer.wms(urlObject.contourC,{...option}).addTo(this.dgLayer);

        this.map.addLayer(this.dgLayer);
      }else{
        this.map.removeLayer(this.dgLayer);
        this.dgLayer = null;
        this.showDgLayer = false;
      }

    // , {
    //     pane: 'layerPane',
    //             maxZoom: this.maxZoom,
    //             minZoom: 12,
    //             reuseTiles: true,
    //             opacity: 1
    //   }
    },
    hasSameWms(id){
      let result = false;
      this.wmsLayers.eachLayer((layer) => {
        if (layer.options.id == id) {
          result= true; // 已存在相同id的图层
        }
      });
      return result;
    },
    delWms(ids){
      this.wmsLayers.eachLayer((layer) => {
        if (ids.indexOf(layer.options.id) == -1) {
          layer.remove();
        }
      });
    },
    drawWmsLayer(arr){
      const _this = this;
      if(arr.length == 0){
        if(this.wmsLayers){
          this.wmsLayers.clearLayers();
          this.map.removeLayer(this.wmsLayers);
          this.wmsLayers = null;
        }
        return;
      }
      if(!this.wmsLayers){
        this.wmsLayers = L.layerGroup();
        this.map.addLayer(this.wmsLayers);
      }
      let currentGroup = [];
      for(let i=0;i<arr.length;i++){
        if(arr[i].adcode && arr[i].adcode.substr(4,2) == '00' && arr[i].itemType == 2){
          currentGroup.push(arr[i].adcode);
          const result = _this.hasSameWms(arr[i].adcode);
          if(!result){
            let option = {
              id: arr[i].adcode,
              layers: 'dx:'+ arr[i].adcode,
              format: 'image/png',
              transparent: true,
              opacity: 1,
              version: '1.3.0'
            }
            L.tileLayer.wms(HOST+"/geoserver/dx/wms?",{...option}).addTo(this.wmsLayers);
          }
        }

      }
      this.delWms(currentGroup);


    },

    defaultWmsLayer(code){
      if(this.defaultLayer){
        this.map.removeLayer(this.defaultLayer);
        this.defaultLayer = null;
      }
      if(!code){
       return;
      }

      let option = {
        layers: 'dx:'+ code,
        format: 'image/png',
        transparent: true,
        opacity: 1,
        version: '1.3.0'
      }
      const wms = L.tileLayer.wms(HOST+"/geoserver/dx/wms?",{...option});
      wms.setZIndex(1000)
      this.defaultLayer = L.layerGroup([wms]);
      this.map.addLayer(this.defaultLayer);
    },
    defaultImageLayer(data){
      if(this.defaultImgLayer){
        this.map.removeLayer(this.defaultImgLayer);
        this.defaultImgLayer = null;
      }
      if(!data){
        return;
      }
      this.defaultImgLayer = L.imageOverlay(
              data.url,
              data.latlngs.map(l => [l.lat, l.lng]),
              { opacity: 0.5 }
      );
      this.map.addLayer(this.defaultImgLayer);
    },

    /**
     * 设置marker的默认图片
     * icon 不传时，则恢复为 leaflet 默认的图片
     */
    setDefaultIcon(icon) {
      if (!icon) {
        L.Marker.prototype.options.icon = this.defaultMarker;
        return;
      }
      L.Marker.prototype.options.icon = icon;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  }
};
</script>

<style lang="less">
  .leaflet-bottom .leaflet-control-pos{
    left:420px;
  }
  .leaflet-bottom{
    bottom: 40px;
  }
  .leaflet-icon.my-custom-icon {
    width: 150px;
    height: 150px;
  }
#polyline-measure-control {
  border: none;
}
.map-container {
  position: relative;
  height: 100%;
  flex: 1;

  #map-root {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    // .leaflet-pm-toolbar {
    //   &.leaflet-bar.leaflet-control {
    //     display: flex;

    //     a:first-child {
    //       border-radius: 0;
    //     }
    //   }
    // }
    .leaflet-control-scale-line {
      text-align: center;
    }
  }

  .map-control-switch {
    position: absolute;
    left: 6px;
    bottom:0;
    z-index: 1000;
    margin-bottom: 5px;
    pointer-events: auto;
  }

  .leaflet-control {
    display: flex;

    a {
      height: 30px;
      width: 30px;
      display: block;
    }

    a:first-child {
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
      border-top-right-radius: 0px;
      border: none;
    }

    a:last-child {
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      border-bottom-left-radius: 0px;
    }

    // &.leaflet-bar {
    //   a {
    //     background-color: #fff;
    //   }
    //   a:first-child {
    //     border-top-left-radius: 0px;
    //     border-top-right-radius: 0px;
    //   }
    //   a:last-child {
    //     border-bottom-left-radius: 0px;
    //     border-bottom-right-radius: 0px;
    //   }
    // }
  }
}
</style>
